/**
 * A alça "⠿" que começa o arraste de uma linha de lançamento.
 *
 * Papel: reproduz `.drag-handle` (l. 76–77): o símbolo em 16 px na cor
 * `--emb-alca`, `0 6px`, cursor de mão aberta, sem seleção de texto e com
 * `touch-action:none`, que impede o dedo de rolar a página no lugar de
 * arrastar.
 *
 * Como usar: quem monta passa o `onPointerDown`, que é onde o arraste começa —
 * a origem só começa o arraste na alça, e a linha inteira não é arrastável.
 */
import { type PointerEvent } from 'react';

/**
 * A alça de uma linha.
 *
 * @param onPointerDown - Chamado quando o ponteiro aperta a alça.
 * @returns O `<span>` com "⠿".
 */
export function AlcaDeArraste({
  onPointerDown,
}: {
  onPointerDown: (evento: PointerEvent<HTMLSpanElement>) => void;
}) {
  return (
    <span
      title="Arrastar para reordenar"
      onPointerDown={onPointerDown}
      className="inline-block cursor-grab touch-none px-1.5 text-[16px] leading-none text-emb-alca select-none hover:text-foreground"
    >
      ⠿
    </span>
  );
}
